module.exports = __webpack_public_path__ + "static/media/xray-training-kneecap-view3.b960f819.png";